"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RuleDefaultProps = exports.Rule = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Rule = function Rule(props) {
  var classNames = props.classNames,
      size = props.size;
  var ruleClassNames = (0, _classnames.default)('rule-component', ["rule-component__size-".concat(size)], classNames);
  return _react.default.createElement("div", {
    className: ruleClassNames
  });
};

exports.Rule = Rule;
Rule.propTypes = {
  classNames: _propTypes.default.any.isRequired,
  size: _propTypes.default.oneOf(['large', 'small']).isRequired
};
var RuleDefaultProps = {
  classNames: '',
  size: 'small'
};
exports.RuleDefaultProps = RuleDefaultProps;
Rule.defaultProps = RuleDefaultProps;
var _default = Rule;
exports.default = _default;